import { request } from "./client";
import ApiConfig from "../constants/api";

export function getServerList() {
  return Promise.resolve(request(ApiConfig.SERVER_LIST, "GET"));
}

export function createServer(params) {
  return Promise.resolve(request(ApiConfig.CREATE_SERVER, "POST", params));
}

export function getDetailServer(id) {
  return Promise.resolve(request(ApiConfig.DETAIL_SERVER + "/" + id, "GET"));
}

export function updateServer(id, params) {
  return Promise.resolve(
    request(ApiConfig.UPDATE_SERVER + "/" + id, "PUT", params)
  );
}

export function changeStatus(id, status) {
  return Promise.resolve(
    request(ApiConfig.UPDATE_STATUS_SERVER + "/" + id, "PUT", { status })
  );
}

export function getNotificationList() {
  return Promise.resolve(request(ApiConfig.GET_LIST_NOTIFICATION, "GET"));
}

export function getStatus(id) {
  return Promise.resolve(
    request(ApiConfig.GET_LASTEST_NOTIFICATION + "/" + id, "GET")
  );
}

export function checkServer(params) {
  return Promise.resolve(
    request(ApiConfig.CHECK_STATUS_SERVER, "POST", params)
  );
}
